import { UserService } from '@fnv-core/authentication';
import * as $ from 'jquery';


function initLogoutController() {
    $(".js-logout").click(function(event) {
        event.preventDefault();
        UserService.removeCookiesOnLogout();
        location.href = "/logout";
        return false;
    });
}
export { initLogoutController };
